import { z } from 'zod';

export const dcValidationLogSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  deleted: z.boolean(),
  isFromManager: z.boolean(),
  createdDate: z.string(),
  representativeId: z.string().optional(),
  representativeName: z.string().optional(),
  tableName: z.string(),
  remotedCode: z.string(),
  validationRuleDescription: z.string().optional(),
  exported: z.boolean(),
  lastExported: z.string().optional(),
});

export const getDCValidationLogsWithConditionsSchema = z.array(dcValidationLogSchema);

export type GetDCValidationLogsWithConditionsResponse = z.infer<
  typeof getDCValidationLogsWithConditionsSchema
>;
